import { render, staticRenderFns } from "./Proximamente.vue?vue&type=template&id=47f83f84&scoped=true&"
import script from "./Proximamente.vue?vue&type=script&lang=js&"
export * from "./Proximamente.vue?vue&type=script&lang=js&"
import style0 from "./Proximamente.vue?vue&type=style&index=0&id=47f83f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f83f84",
  null
  
)

export default component.exports